import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    UPDATE_TEMPLATE_DETAILS_SUCCESS,
    UPDATE_TEMPLATE_DETAILS_FAILURE
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

import {
    updateProductTemplateDataService,
} from 'src/pages/more/pages/templates/redux/services/index.js';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* updateTemplateDetails(action) {
    try {
        const result = yield updateProductTemplateDataService({ ...action.payload });
        yield put({
            type: UPDATE_TEMPLATE_DETAILS_SUCCESS,
            payload: result || {},
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/order/templates/${action.payload?.templateUID}`,
            requestPayload: action.payload,
        });
        yield put({
            type: UPDATE_TEMPLATE_DETAILS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}


// export function* updateTemplateDetails(action, carrierValue) {
//     const id= action.payload.templateUID;
//     const url = `occ/v2/${localStorage.getItem('baseSiteId')}/products/template/${id}`;
//     const accounts = action.payload.accounts;
//     const physician = action.payload.physician;
//     const procedureCode = action.payload.carrierPickupNotifications;
//     const templateName = action.payload.templateName;
//     try {
//         const result = yield axios
//             .put(url, { ...action.payload })
//             .then((response) => response.data);

//         result.accountNumber = action.payload.accountNumber;
//         result.accounts = accounts;
//         result.physician = physician;
//         result.procedureCode = procedureCode;
//         result.templateName = templateName;
//         yield put({
//             type: UPDATE_TEMPLATE_DETAILS_SUCCESS,
//             payload: result || {},
//         });
//     } catch (e) {
//         console.log(e);
//         yield put({
//             type: UPDATE_TEMPLATE_DETAILS_FAILURE,
//             statusCode: errorHandler('503'),
//             statusMessage: e.Error,
//         });
//     }
// }
